<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 lg3 md4 sm6 class="box">
        <market-data-separator
          :market="market"
          :data-source="availableCcyPairs"
          :value="ccyPairs"
          v-slot="{dataSource: ds, marketValues, selectedValues}"
        >
          <vonap-form-label :label="market.marketCode == 'FX' ? 'Ccy Pairs' : 'Ccy / Commodity'">
            <vonap-switch-list
              :use-v-card="false"
              :is-disabled="isDisabled"
              max-height="400px"
              flex-size="xs6 "
              :data-source="ds"
              data-value-field="ccyPairId"
              data-text-field="ccyPair"
              :value="marketValues"
              @input="$emit('update:ccyPairs', selectedValues($event))"
              width="130px"
            />
          </vonap-form-label>
        </market-data-separator>
      </v-flex>
      <v-flex xs12 lg3 md4 sm6 class="box">
        <market-data-separator
          :market="market"
          :data-source="dataSource.products"
          :value="products"
          v-slot="{dataSource: ds, marketValues, selectedValues}"
        >
          <vonap-form-label label="Products">
            <vonap-switch-list
              hide-search
              :use-v-card="false"
              :is-disabled="isDisabled"
              max-height="400px"
              flex-size="xs6"
              :data-source="ds"
              :selected-toolbar-tools="['moveUp', 'moveDown']"
              data-value-field="productId"
              data-text-field="productCode"
              :value="marketValues"
              @input="$emit('update:products', selectedValues($event))"
              width="130px"
            />
          </vonap-form-label>
        </market-data-separator>
      </v-flex>
      <v-flex xs12 lg3 md4 sm6 class="box">
        <market-data-separator
          :market="market"
          :data-source="dataSource.counterparties"
          :value="counterparties"
          v-slot="{dataSource: ds, marketValues, selectedValues}"
        >
          <vonap-form-label label="Counterparty/Broker">
            <vonap-switch-list
              :use-v-card="false"
              :is-disabled="isDisabled"
              max-height="400px"
              flex-size="xs6"
              :data-source="ds"
              :selected-toolbar-tools="['moveUp', 'moveDown']"
              data-value-field="counterpartyId"
              data-text-field="counterpartyName"
              :value="marketValues"
              @input="$emit('update:counterparties', selectedValues($event))"
              width="130px"
            />
          </vonap-form-label>
        </market-data-separator>
      </v-flex>
      <v-flex xs12 lg3 md4 sm6 class="box">
        <market-data-separator
          :market="market"
          :data-source="dataSource.processes"
          :value="processes"
          v-slot="{dataSource: ds, marketValues, selectedValues}"
        >
          <vonap-form-label label="Processes">
            <vonap-switch-list
              :use-v-card="false"
              :is-disabled="isDisabled"
              max-height="400px"
              flex-size="xs12"
              :data-source="ds"
              :value="marketValues"
              @input="$emit('update:processes', selectedValues($event))"
              data-value-field="processId"
              data-text-field="processName"
            />
          </vonap-form-label>
        </market-data-separator>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import MarketDataSeparator from '../MarketDataSeparator'
import VonapFormLabel from '@/components/VonapFormLabel'
import VonapSwitchList from '@/components/VonapSwitchList'

export default {
  props: [
    'market',
    'dataSource',
    'counterparties',
    'ccies',
    'ccyPairs',
    'processes',
    'products',
    'isDisabled',
  ],
  computed: {
    availableCcyPairs() {
      const ccies = this.ccies
      return this.dataSource.ccyPairs.filter(pair =>
        ccies.some(ccy => pair.ccyPair.includes(ccy.ccy)),
      )
    },
  },
  components: {
    MarketDataSeparator,
    VonapFormLabel,
    VonapSwitchList,
  },
}
</script>

<style>
.box {
  overflow-y: auto;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
</style>
